module.exports = __webpack_public_path__ + "media/customizations/shellstonelife/logo-new-619459c18290492d92bb84b433400865.png";